<template lang="pug">
md-input-container
  label(for='network') Education
  md-select(name='education', :multiple='multiple', v-model='selected', @selected='onSelected')
    md-option(v-for='item in items', :value='item.key', :key='item.key') {{ item.value }}
</template>

<script>
  import { metrics } from '../../assets/data/demographics';

  export default {
    props: {
      value: {
        type: [String, Array],
        required: true
      },
      multiple: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selected: this.value,
        items: metrics.education
      };
    },
    methods: {
      onSelected(value) {
        this.$emit('input', value);
      }
    },
    watch: {
      value(newValue) {
        if (newValue) {
          this.selected = newValue;
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/shared-components/demographic/EducationSelector.vue